<template>
    <div class="">

        <div class="">

            <b-form-file 
              v-model="file" 
              :ref="'file-input-'+this.input" 
              :disabled="disabled"
              :accept="accept"
              :multiple="multiple"
              @change="handleChange"
              placeholder="Escolher arquivo..."
              drop-placeholder="Apagar arquivo..."
              browse-text="Procurar..." 
            >
              <template slot="file-name" slot-scope="{ names }">
                <b-badge variant="dark">{{ names[0] }}</b-badge>
                <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
                  + {{ names.length - 1 }} More files
                </b-badge>
              </template>
            </b-form-file>
        </div>

        <div class="arquivo-info" v-if="currentFile != null">
          <Download :arquivo="currentFile" @deleted="handleDeleted"/>
        </div>
        
    </div>
</template>

<script>

    import Download from 'common/download';

    export default {
        name:"ed-upload",
        components:{Download},
        mixins:[],

        props:{
          onChangeFile:{
            type:Function,
            default:function () { return {} }
          },
          currentFile:{
            type:[Object,Array,File],
            default:function () { return null }
          },
          disabled:{
            type:Boolean,
            default:function(){return false}
          },
          multiple:{
            type:Boolean,
            default:function(){return false}
          },
          accept:{
            type:String,
            default:function(){return ''}
          },
          input:{
            type:String,
            default:function(){return (new Date()).getTime().toString()}
          }
        },
         watch:{
          onChangeFile(){
          },
          currentFile(){
            if(this.currentFile && this.currentFile.id){
              this.file = new File(['foo'], this.currentFile.name,this.currentFile);
            }
            else{
              this.file = this.currentFile;
            }
          },
          accept(){
          },
          multiple(){
          },
          disabled(){
          },
          input(){
          }
        },

        data () {
          return {
            file: null,
            loadingDelete:false
          }
        },

        mounted() {
          this.clearFiles();
        },

        methods:{

          clearFiles() {
            this.$refs['file-input-'+this.input].reset()
          },

          handleChange(e){
            if(this.onChangeFile)
              this.onChangeFile(e);

            e.preventDefault();

            this.$events.fire('upload-'+this.input,e.target.files[0]);
            //this.$events.fire('upload-'+this.input,e.target.files);
          },

          handleDeleted(){
            this.file = null;
            this.$events.fire('upload-'+this.input, null);
            this.$events.fire('upload-deleted-'+this.input);
          },
        }
    }
</script>


<style scoped>

  #fileselector .btn-default{
    color:#666 !important;
    padding: 8px;
    width:100%;
  }

  #fileselector .btn-default:hover{
    color:#666 !important;
  }
  .arquivo-info{
    width: 100%;
    font-style: italic;
    font-size: 10pt;
  }
  .el-image-viewer__wrapper{
		z-index: 9999999999999999 !important;
	}
</style>


// WEBPACK FOOTER //
// upload.vue?481b9bf2